<template>
  <div class="page-title-bar">
    <div class="page-title-bar__content">
      <button
        v-if="onBack"
        class="back-link page-title-bar__back"
        type="button"
        :aria-label="backLabel"
        @click="onBack"
      >
        <v-icon icon="mdi-arrow-left" size="20" />
        <span class="page-title-bar__back-label">{{ backLabel }}</span>
      </button>
      <router-link
        v-else-if="backTo"
        class="back-link page-title-bar__back"
        :to="backTo"
        :aria-label="backLabel"
      >
        <v-icon
          icon="mdi-arrow-left"
          size="20"
        />
        <span class="page-title-bar__back-label">{{ backLabel }}</span>
      </router-link>

      <h1
        class="page-title-bar__title"
        :class="{ 'page-title-bar__title--with-back': backTo || onBack }"
      >
        {{ title }}
      </h1>

      <div
        v-if="hasActions"
        class="page-title-bar__actions"
      >
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, useSlots } from 'vue'

defineProps({
  title: {
    type: String,
    required: true,
  },

  backTo: {
    type: [String, Object],
    default: null,
  },

  backLabel: {
    type: String,
    default: 'Natrag',
  },

  onBack: {
    type: Function,
    default: null,
  },
})

const slots = useSlots()
const hasActions = computed(() => Boolean(slots.actions))
</script>

<style
  scoped
  lang="scss"
>
.page-title-bar {
  width: calc(100% + (var(--page-padding-inline) * 2));
  margin: calc(var(--page-padding-block) * -1) 0 24px calc(var(--page-padding-inline) * -1);
  border-bottom: 0;
  background: var(--color-page-background);

  @include breakpoint-up("sm") {
    margin: calc(var(--page-padding-block) * -1) 0 clamp-bp("sm", "xl", 40, 48) calc(var(--page-padding-inline) * -1);
    border-bottom: 1px solid var(--color-border);
    background: var(--color-white);
  }
  &__content {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 12px;
    min-height: 72px;
    padding: 16px var(--page-padding-inline);

    @include breakpoint-up("sm") {
      gap: 14px;
      min-height: 86px;
      padding: 24px var(--page-padding-inline);
    }
  }

  &__title {
    flex: 1 1 auto;
    margin: 0;

    @include breakpoint-up("sm") {
      flex: 0 1 auto;
    }
  }

  &__back {
    justify-content: center;
    flex: 0 0 auto;
    padding: 0;
    border: 0;
    background: none;
    cursor: pointer;
  }

  &__back-label {
    display: inline;

    @include breakpoint-up("sm") {
      display: none;
    }
  }

  &__actions {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    justify-content: flex-end;
    gap: 12px;
    margin-left: auto;
  }

  &__title--with-back {
    display: none;

    @include breakpoint-up("sm") {
      display: block;
    }
  }
}
</style>
